var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"app"},[_c('a-config-provider',{attrs:{"locale":_vm.ko_KR}},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('Footer')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }